module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/head.cffe4ed5.png";